import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLogin, setPass, connectUser, setError, resetError, setRole, setJems32 } from "../redux/appSlice";
import { Button, Grid, Segment, Header, Image, Form } from "semantic-ui-react";
import axios from 'axios';
import logo from '../assets/logo.png';

const Login = () => {
  const appState = useSelector(state => state.app);
  const dispatch = useDispatch();

  const onLoginChange = (e, data) => {
    dispatch(setLogin(data.value));
  };

  const onPassChange = (e, data) => {
    dispatch(setPass(data.value));
  };

  const onLogin = async (email, password) => {
    try {
      const API_URL = process.env.REACT_APP_BASE_API_URL;
      console.log('Attempting login for', API_URL);
      const srvTest = process.env.REACT_APP_TEST;
      const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
      let res = await axios.post(API_URL + '/auth/login', { email, password }, options)
      dispatch(resetError(false))
      srvTest === "0" ? dispatch(setJems32(false)) : dispatch(setJems32(true));
      if (res.status === 200) {
        dispatch(connectUser(true));
        dispatch(setRole(res.data.role.name));
        dispatch(setPass(''));
      } else {
        dispatch(setError('Connexion Failed, Please try again'))
        dispatch(connectUser(false));
        dispatch(setRole(''))
      }
    } catch (e) {
      dispatch(setError('Connexion Failed, Please try again'))
      dispatch(connectUser(false));
    }
  };

  return (
    <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>
        <Image src={logo} />
        <Header as='h2' color='blue' textAlign='center'>
          <p>Log-in to Report Generator for Jems</p>
        </Header>
        <Form size='large'>
          <Segment raised>
            <Form.Input fluid icon='user'
              iconPosition='left'
              placeholder='E-mail address'
              value={appState.login}
              onChange={onLoginChange}
            />
            <Form.Input
              fluid
              icon='lock'
              iconPosition='left'
              placeholder='JEMS Password'
              type='password'
              value={appState.pass}
              onChange={onPassChange}
            />
            <Button color='blue' fluid size='large' onClick={() => onLogin(appState.login, appState.pass)}>
              Login
            </Button>
          </Segment>
        </Form>
        {/* {appState.error? <Message negative><Message.Header>{appState.msgError}</Message.Header></Message> : undefined } */}
      </Grid.Column>
    </Grid>
  );
}

export default Login;